/* eslint-disable camelcase */
// import X from 'Y';
import _ from 'lodash';

const RECURSO = {
    "status": 0,
    "data": [
        {
            "id": 0,
            "nome": "GERAL",
            "total": 4122826,
            "abertas": 334506,
            "finalizadas": 3662581,
            "canceladas": 119868,
            "indeferidas": 1010736,
            "deferidas": 2651845,
            "servicos": [
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 482522,
                    "abertas": 23233,
                    "finalizadas": 435592,
                    "canceladas": 23323,
                    "indeferidas": 118865,
                    "deferidas": 316727,
                    "media_atendimento_dias": 112.78489434509
                },
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 352753,
                    "abertas": 62181,
                    "finalizadas": 256356,
                    "canceladas": 32620,
                    "indeferidas": 109856,
                    "deferidas": 146500,
                    "media_atendimento_dias": 431.1928218321
                },
                {
                    "servico_id": 538,
                    "servico_desc": "Serviço Especializado de Abordagem Social às Pessoas em Situação de Rua - SEAS",
                    "total": 310335,
                    "abertas": 681,
                    "finalizadas": 303767,
                    "canceladas": 4649,
                    "indeferidas": 19161,
                    "deferidas": 284606,
                    "media_atendimento_dias": 68.500858622193
                },
                {
                    "servico_id": 520,
                    "servico_desc": "Reparo de lâmpada",
                    "total": 289165,
                    "abertas": 284,
                    "finalizadas": 288353,
                    "canceladas": 384,
                    "indeferidas": 254268,
                    "deferidas": 34085,
                    "media_atendimento_dias": 429.67775653221
                },
                {
                    "servico_id": 516,
                    "servico_desc": "Remoção de veículo/carcaça abandonado na via pública",
                    "total": 142552,
                    "abertas": 31159,
                    "finalizadas": 108434,
                    "canceladas": 2796,
                    "indeferidas": 11210,
                    "deferidas": 97224,
                    "media_atendimento_dias": 450.36973833645
                }
            ]
        },
        {
            "id": 1,
            "nome": "PIRITUBA-JARAGUA",
            "total": 151290,
            "abertas": 10016,
            "finalizadas": 139351,
            "canceladas": 1760,
            "indeferidas": 55498,
            "deferidas": 83853,
            "servicos": [
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 21362,
                    "abertas": 1021,
                    "finalizadas": 20206,
                    "canceladas": 113,
                    "indeferidas": 6651,
                    "deferidas": 13555,
                    "media_atendimento_dias": 72.098122381211
                },
                {
                    "servico_id": 520,
                    "servico_desc": "Reparo de lâmpada",
                    "total": 20060,
                    "abertas": 9,
                    "finalizadas": 20029,
                    "canceladas": 14,
                    "indeferidas": 18626,
                    "deferidas": 1403,
                    "media_atendimento_dias": 338.09116229112
                },
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 15262,
                    "abertas": 1568,
                    "finalizadas": 13610,
                    "canceladas": 66,
                    "indeferidas": 9162,
                    "deferidas": 4448,
                    "media_atendimento_dias": 202.62742591083
                },
                {
                    "servico_id": 530,
                    "servico_desc": "Roçada em praças e canteiro central",
                    "total": 6863,
                    "abertas": 132,
                    "finalizadas": 6695,
                    "canceladas": 27,
                    "indeferidas": 1920,
                    "deferidas": 4775,
                    "media_atendimento_dias": 82.536798298429
                },
                {
                    "servico_id": 516,
                    "servico_desc": "Remoção de veículo/carcaça abandonado na via pública",
                    "total": 6110,
                    "abertas": 1068,
                    "finalizadas": 4931,
                    "canceladas": 99,
                    "indeferidas": 65,
                    "deferidas": 4866,
                    "media_atendimento_dias": 217.85502330275
                }
            ],
            "media_atendimento_dias": 198.9
        },
        {
            "id": 2,
            "nome": "FREGUESIA-BRASILANDIA",
            "total": 136422,
            "abertas": 11196,
            "finalizadas": 123952,
            "canceladas": 1121,
            "indeferidas": 37250,
            "deferidas": 86702,
            "servicos": [
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 20018,
                    "abertas": 855,
                    "finalizadas": 19051,
                    "canceladas": 94,
                    "indeferidas": 2110,
                    "deferidas": 16941,
                    "media_atendimento_dias": 156.26126448928
                },
                {
                    "servico_id": 520,
                    "servico_desc": "Reparo de lâmpada",
                    "total": 19592,
                    "abertas": 4,
                    "finalizadas": 19580,
                    "canceladas": 3,
                    "indeferidas": 18585,
                    "deferidas": 995,
                    "media_atendimento_dias": 453.8370458659
                },
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 7937,
                    "abertas": 1775,
                    "finalizadas": 5957,
                    "canceladas": 164,
                    "indeferidas": 1870,
                    "deferidas": 4087,
                    "media_atendimento_dias": 396.84902712927
                },
                {
                    "servico_id": 516,
                    "servico_desc": "Remoção de veículo/carcaça abandonado na via pública",
                    "total": 5662,
                    "abertas": 1859,
                    "finalizadas": 3686,
                    "canceladas": 106,
                    "indeferidas": 179,
                    "deferidas": 3507,
                    "media_atendimento_dias": 363.38646520451
                },
                {
                    "servico_id": 278,
                    "servico_desc": "Fiscalização de descarte irregular de entulho e outros resíduos em área pública",
                    "total": 3788,
                    "abertas": 46,
                    "finalizadas": 3730,
                    "canceladas": 12,
                    "indeferidas": 932,
                    "deferidas": 2798,
                    "media_atendimento_dias": 106.9407742675
                }
            ],
            "media_atendimento_dias": 244.67
        },
        {
            "id": 3,
            "nome": "CASA VERDE-CACHOEIRINHA",
            "total": 144773,
            "abertas": 8865,
            "finalizadas": 130289,
            "canceladas": 5478,
            "indeferidas": 39214,
            "deferidas": 91075,
            "servicos": [
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 19277,
                    "abertas": 716,
                    "finalizadas": 16012,
                    "canceladas": 2537,
                    "indeferidas": 5225,
                    "deferidas": 10787,
                    "media_atendimento_dias": 115.72622471665
                },
                {
                    "servico_id": 520,
                    "servico_desc": "Reparo de lâmpada",
                    "total": 17982,
                    "abertas": 11,
                    "finalizadas": 17957,
                    "canceladas": 9,
                    "indeferidas": 16830,
                    "deferidas": 1127,
                    "media_atendimento_dias": 377.32369494356
                },
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 10391,
                    "abertas": 1330,
                    "finalizadas": 8409,
                    "canceladas": 628,
                    "indeferidas": 3769,
                    "deferidas": 4640,
                    "media_atendimento_dias": 208.87842605813
                },
                {
                    "servico_id": 538,
                    "servico_desc": "Serviço Especializado de Abordagem Social às Pessoas em Situação de Rua - SEAS",
                    "total": 7543,
                    "abertas": 1,
                    "finalizadas": 7394,
                    "canceladas": 124,
                    "indeferidas": 252,
                    "deferidas": 7142,
                    "media_atendimento_dias": 41.210046401633
                },
                {
                    "servico_id": 516,
                    "servico_desc": "Remoção de veículo/carcaça abandonado na via pública",
                    "total": 5494,
                    "abertas": 795,
                    "finalizadas": 4606,
                    "canceladas": 86,
                    "indeferidas": 178,
                    "deferidas": 4428,
                    "media_atendimento_dias": 142.86840386775
                }
            ],
            "media_atendimento_dias": 209.74
        },
        {
            "id": 4,
            "nome": "SANTANA-TUCURUVI",
            "total": 210317,
            "abertas": 15615,
            "finalizadas": 190374,
            "canceladas": 4105,
            "indeferidas": 66616,
            "deferidas": 123758,
            "servicos": [
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 30882,
                    "abertas": 1006,
                    "finalizadas": 28904,
                    "canceladas": 948,
                    "indeferidas": 15495,
                    "deferidas": 13409,
                    "media_atendimento_dias": 106.35226431322
                },
                {
                    "servico_id": 197,
                    "servico_desc": "Denúncia de reciclagem irregular",
                    "total": 21794,
                    "abertas": 1595,
                    "finalizadas": 20191,
                    "canceladas": 8,
                    "indeferidas": 0,
                    "deferidas": 20191,
                    "media_atendimento_dias": 256.67584459156
                },
                {
                    "servico_id": 520,
                    "servico_desc": "Reparo de lâmpada",
                    "total": 17988,
                    "abertas": 7,
                    "finalizadas": 17963,
                    "canceladas": 16,
                    "indeferidas": 16846,
                    "deferidas": 1117,
                    "media_atendimento_dias": 437.69574352805
                },
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 17911,
                    "abertas": 2418,
                    "finalizadas": 14523,
                    "canceladas": 947,
                    "indeferidas": 11327,
                    "deferidas": 3196,
                    "media_atendimento_dias": 438.38693161011
                },
                {
                    "servico_id": 538,
                    "servico_desc": "Serviço Especializado de Abordagem Social às Pessoas em Situação de Rua - SEAS",
                    "total": 15665,
                    "abertas": 25,
                    "finalizadas": 15344,
                    "canceladas": 215,
                    "indeferidas": 1210,
                    "deferidas": 14134,
                    "media_atendimento_dias": 77.154479884826
                }
            ],
            "media_atendimento_dias": 279.15
        },
        {
            "id": 5,
            "nome": "JACANA-TREMEMBE",
            "total": 99704,
            "abertas": 2961,
            "finalizadas": 88207,
            "canceladas": 8459,
            "indeferidas": 35746,
            "deferidas": 52461,
            "servicos": [
                {
                    "servico_id": 520,
                    "servico_desc": "Reparo de lâmpada",
                    "total": 13944,
                    "abertas": 15,
                    "finalizadas": 13913,
                    "canceladas": 11,
                    "indeferidas": 12829,
                    "deferidas": 1084,
                    "media_atendimento_dias": 408.72022648456
                },
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 11184,
                    "abertas": 185,
                    "finalizadas": 9690,
                    "canceladas": 1300,
                    "indeferidas": 3234,
                    "deferidas": 6456,
                    "media_atendimento_dias": 44.120897906842
                },
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 7518,
                    "abertas": 304,
                    "finalizadas": 5627,
                    "canceladas": 1580,
                    "indeferidas": 2528,
                    "deferidas": 3099,
                    "media_atendimento_dias": 317.74780525453
                },
                {
                    "servico_id": 279,
                    "servico_desc": "Fiscalização de estabelecimentos comerciais e serviços",
                    "total": 4260,
                    "abertas": 52,
                    "finalizadas": 4202,
                    "canceladas": 6,
                    "indeferidas": 3003,
                    "deferidas": 1199,
                    "media_atendimento_dias": 293.15805220593
                },
                {
                    "servico_id": 516,
                    "servico_desc": "Remoção de veículo/carcaça abandonado na via pública",
                    "total": 3127,
                    "abertas": 161,
                    "finalizadas": 2949,
                    "canceladas": 13,
                    "indeferidas": 399,
                    "deferidas": 2550,
                    "media_atendimento_dias": 174.0011492874
                }
            ],
            "media_atendimento_dias": 147.4
        },
        {
            "id": 6,
            "nome": "VILA MARIA-VILA GUILHERME",
            "total": 105656,
            "abertas": 6196,
            "finalizadas": 94297,
            "canceladas": 5059,
            "indeferidas": 31699,
            "deferidas": 62598,
            "servicos": [
                {
                    "servico_id": 520,
                    "servico_desc": "Reparo de lâmpada",
                    "total": 14107,
                    "abertas": 7,
                    "finalizadas": 14086,
                    "canceladas": 9,
                    "indeferidas": 13300,
                    "deferidas": 786,
                    "media_atendimento_dias": 348.14468163934
                },
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 8791,
                    "abertas": 1387,
                    "finalizadas": 6794,
                    "canceladas": 583,
                    "indeferidas": 1813,
                    "deferidas": 4981,
                    "media_atendimento_dias": 344.20905628193
                },
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 6772,
                    "abertas": 79,
                    "finalizadas": 6639,
                    "canceladas": 51,
                    "indeferidas": 2523,
                    "deferidas": 4116,
                    "media_atendimento_dias": 98.074930145008
                },
                {
                    "servico_id": 516,
                    "servico_desc": "Remoção de veículo/carcaça abandonado na via pública",
                    "total": 4612,
                    "abertas": 413,
                    "finalizadas": 4148,
                    "canceladas": 48,
                    "indeferidas": 59,
                    "deferidas": 4089,
                    "media_atendimento_dias": 178.76892367338
                },
                {
                    "servico_id": 471,
                    "servico_desc": "Reclamação de falta de varrição",
                    "total": 3122,
                    "abertas": 64,
                    "finalizadas": 2513,
                    "canceladas": 545,
                    "indeferidas": 185,
                    "deferidas": 2328,
                    "media_atendimento_dias": 212.27947075458
                }
            ],
            "media_atendimento_dias": 199.88
        },
        {
            "id": 7,
            "nome": "PENHA",
            "total": 182083,
            "abertas": 13862,
            "finalizadas": 164277,
            "canceladas": 3789,
            "indeferidas": 55066,
            "deferidas": 109211,
            "servicos": [
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 24514,
                    "abertas": 2065,
                    "finalizadas": 21555,
                    "canceladas": 876,
                    "indeferidas": 8000,
                    "deferidas": 13555,
                    "media_atendimento_dias": 89.820133041655
                },
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 18620,
                    "abertas": 1803,
                    "finalizadas": 15988,
                    "canceladas": 805,
                    "indeferidas": 8196,
                    "deferidas": 7792,
                    "media_atendimento_dias": 114.93245657643
                },
                {
                    "servico_id": 520,
                    "servico_desc": "Reparo de lâmpada",
                    "total": 12086,
                    "abertas": 12,
                    "finalizadas": 12053,
                    "canceladas": 14,
                    "indeferidas": 10814,
                    "deferidas": 1239,
                    "media_atendimento_dias": 352.23056275782
                },
                {
                    "servico_id": 530,
                    "servico_desc": "Roçada em praças e canteiro central",
                    "total": 6495,
                    "abertas": 170,
                    "finalizadas": 6248,
                    "canceladas": 69,
                    "indeferidas": 1295,
                    "deferidas": 4953,
                    "media_atendimento_dias": 89.813840389009
                },
                {
                    "servico_id": 279,
                    "servico_desc": "Fiscalização de estabelecimentos comerciais e serviços",
                    "total": 5929,
                    "abertas": 591,
                    "finalizadas": 5218,
                    "canceladas": 118,
                    "indeferidas": 1623,
                    "deferidas": 3595,
                    "media_atendimento_dias": 1232.9686269993
                }
            ],
            "media_atendimento_dias": 270.82
        },
        {
            "id": 8,
            "nome": "ERMELINO MATARAZZO",
            "total": 50529,
            "abertas": 2486,
            "finalizadas": 47158,
            "canceladas": 827,
            "indeferidas": 13561,
            "deferidas": 33597,
            "servicos": [
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 5069,
                    "abertas": 440,
                    "finalizadas": 4331,
                    "canceladas": 291,
                    "indeferidas": 1196,
                    "deferidas": 3135,
                    "media_atendimento_dias": 121.30784504032
                },
                {
                    "servico_id": 520,
                    "servico_desc": "Reparo de lâmpada",
                    "total": 3609,
                    "abertas": 1,
                    "finalizadas": 3601,
                    "canceladas": 4,
                    "indeferidas": 3191,
                    "deferidas": 410,
                    "media_atendimento_dias": 399.34405643067
                },
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 2316,
                    "abertas": 57,
                    "finalizadas": 2240,
                    "canceladas": 19,
                    "indeferidas": 803,
                    "deferidas": 1437,
                    "media_atendimento_dias": 69.4246587702
                },
                {
                    "servico_id": 516,
                    "servico_desc": "Remoção de veículo/carcaça abandonado na via pública",
                    "total": 1999,
                    "abertas": 136,
                    "finalizadas": 1850,
                    "canceladas": 9,
                    "indeferidas": 238,
                    "deferidas": 1612,
                    "media_atendimento_dias": 175.4752797738
                },
                {
                    "servico_id": 278,
                    "servico_desc": "Fiscalização de descarte irregular de entulho e outros resíduos em área pública",
                    "total": 1926,
                    "abertas": 75,
                    "finalizadas": 1836,
                    "canceladas": 14,
                    "indeferidas": 493,
                    "deferidas": 1343,
                    "media_atendimento_dias": 138.14334335615
                }
            ],
            "media_atendimento_dias": 161.53
        },
        {
            "id": 9,
            "nome": "SAO MIGUEL",
            "total": 87707,
            "abertas": 4641,
            "finalizadas": 76698,
            "canceladas": 6310,
            "indeferidas": 24195,
            "deferidas": 52503,
            "servicos": [
                {
                    "servico_id": 520,
                    "servico_desc": "Reparo de lâmpada",
                    "total": 10602,
                    "abertas": 6,
                    "finalizadas": 10582,
                    "canceladas": 9,
                    "indeferidas": 9927,
                    "deferidas": 655,
                    "media_atendimento_dias": 354.98800696211
                },
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 6541,
                    "abertas": 452,
                    "finalizadas": 5682,
                    "canceladas": 404,
                    "indeferidas": 1246,
                    "deferidas": 4436,
                    "media_atendimento_dias": 383.30187222128
                },
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 5925,
                    "abertas": 95,
                    "finalizadas": 5443,
                    "canceladas": 384,
                    "indeferidas": 1774,
                    "deferidas": 3669,
                    "media_atendimento_dias": 83.09462819746
                },
                {
                    "servico_id": 279,
                    "servico_desc": "Fiscalização de estabelecimentos comerciais e serviços",
                    "total": 3402,
                    "abertas": 368,
                    "finalizadas": 2955,
                    "canceladas": 76,
                    "indeferidas": 1722,
                    "deferidas": 1233,
                    "media_atendimento_dias": 567.1905100196
                },
                {
                    "servico_id": 278,
                    "servico_desc": "Fiscalização de descarte irregular de entulho e outros resíduos em área pública",
                    "total": 2723,
                    "abertas": 199,
                    "finalizadas": 1523,
                    "canceladas": 1001,
                    "indeferidas": 100,
                    "deferidas": 1423,
                    "media_atendimento_dias": 239.06245759155
                }
            ],
            "media_atendimento_dias": 215.79
        },
        {
            "id": 10,
            "nome": "ITAIM PAULISTA",
            "total": 87523,
            "abertas": 7285,
            "finalizadas": 79384,
            "canceladas": 763,
            "indeferidas": 26615,
            "deferidas": 52769,
            "servicos": [
                {
                    "servico_id": 520,
                    "servico_desc": "Reparo de lâmpada",
                    "total": 9103,
                    "abertas": 0,
                    "finalizadas": 9071,
                    "canceladas": 30,
                    "indeferidas": 8229,
                    "deferidas": 842,
                    "media_atendimento_dias": 384.7236854766
                },
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 8750,
                    "abertas": 1282,
                    "finalizadas": 7418,
                    "canceladas": 35,
                    "indeferidas": 4633,
                    "deferidas": 2785,
                    "media_atendimento_dias": 431.40802454452
                },
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 6215,
                    "abertas": 370,
                    "finalizadas": 5798,
                    "canceladas": 40,
                    "indeferidas": 1240,
                    "deferidas": 4558,
                    "media_atendimento_dias": 164.18270799561
                },
                {
                    "servico_id": 278,
                    "servico_desc": "Fiscalização de descarte irregular de entulho e outros resíduos em área pública",
                    "total": 3736,
                    "abertas": 329,
                    "finalizadas": 3367,
                    "canceladas": 39,
                    "indeferidas": 403,
                    "deferidas": 2964,
                    "media_atendimento_dias": 850.35846013661
                },
                {
                    "servico_id": 279,
                    "servico_desc": "Fiscalização de estabelecimentos comerciais e serviços",
                    "total": 3454,
                    "abertas": 410,
                    "finalizadas": 3027,
                    "canceladas": 12,
                    "indeferidas": 1827,
                    "deferidas": 1200,
                    "media_atendimento_dias": 1396.1501557967
                }
            ],
            "media_atendimento_dias": 495.59
        },
        {
            "id": 11,
            "nome": "ITAQUERA",
            "total": 165656,
            "abertas": 20361,
            "finalizadas": 135077,
            "canceladas": 9842,
            "indeferidas": 32393,
            "deferidas": 102684,
            "servicos": [
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 30803,
                    "abertas": 3299,
                    "finalizadas": 19832,
                    "canceladas": 7641,
                    "indeferidas": 867,
                    "deferidas": 18965,
                    "media_atendimento_dias": 154.74985694408
                },
                {
                    "servico_id": 520,
                    "servico_desc": "Reparo de lâmpada",
                    "total": 19895,
                    "abertas": 9,
                    "finalizadas": 19862,
                    "canceladas": 13,
                    "indeferidas": 18382,
                    "deferidas": 1480,
                    "media_atendimento_dias": 398.40923669764
                },
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 11897,
                    "abertas": 3727,
                    "finalizadas": 7574,
                    "canceladas": 416,
                    "indeferidas": 1980,
                    "deferidas": 5594,
                    "media_atendimento_dias": 661.32253427531
                },
                {
                    "servico_id": 530,
                    "servico_desc": "Roçada em praças e canteiro central",
                    "total": 5667,
                    "abertas": 615,
                    "finalizadas": 5022,
                    "canceladas": 25,
                    "indeferidas": 416,
                    "deferidas": 4606,
                    "media_atendimento_dias": 241.52471740262
                },
                {
                    "servico_id": 225,
                    "servico_desc": "Denúncias de locais com acúmulo de água limpa e parada",
                    "total": 4063,
                    "abertas": 76,
                    "finalizadas": 3958,
                    "canceladas": 23,
                    "indeferidas": 203,
                    "deferidas": 3755,
                    "media_atendimento_dias": 115.72028933952
                }
            ],
            "media_atendimento_dias": 295.27
        },
        {
            "id": 12,
            "nome": "GUAIANASES",
            "total": 64935,
            "abertas": 7688,
            "finalizadas": 56145,
            "canceladas": 959,
            "indeferidas": 15749,
            "deferidas": 40396,
            "servicos": [
                {
                    "servico_id": 520,
                    "servico_desc": "Reparo de lâmpada",
                    "total": 5538,
                    "abertas": 1,
                    "finalizadas": 5531,
                    "canceladas": 1,
                    "indeferidas": 4999,
                    "deferidas": 532,
                    "media_atendimento_dias": 433.60083096195
                },
                {
                    "servico_id": 538,
                    "servico_desc": "Serviço Especializado de Abordagem Social às Pessoas em Situação de Rua - SEAS",
                    "total": 4204,
                    "abertas": 1,
                    "finalizadas": 4115,
                    "canceladas": 61,
                    "indeferidas": 143,
                    "deferidas": 3972,
                    "media_atendimento_dias": 39.505350488722
                },
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 4011,
                    "abertas": 101,
                    "finalizadas": 3878,
                    "canceladas": 29,
                    "indeferidas": 1379,
                    "deferidas": 2499,
                    "media_atendimento_dias": 107.84107990418
                },
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 3073,
                    "abertas": 724,
                    "finalizadas": 1999,
                    "canceladas": 303,
                    "indeferidas": 527,
                    "deferidas": 1472,
                    "media_atendimento_dias": 223.22659683694
                },
                {
                    "servico_id": 278,
                    "servico_desc": "Fiscalização de descarte irregular de entulho e outros resíduos em área pública",
                    "total": 2196,
                    "abertas": 354,
                    "finalizadas": 1814,
                    "canceladas": 27,
                    "indeferidas": 113,
                    "deferidas": 1701,
                    "media_atendimento_dias": 420.09959192033
                }
            ],
            "media_atendimento_dias": 346.25
        },
        {
            "id": 13,
            "nome": "LAPA",
            "total": 175853,
            "abertas": 16724,
            "finalizadas": 154877,
            "canceladas": 3868,
            "indeferidas": 37681,
            "deferidas": 117196,
            "servicos": [
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 23625,
                    "abertas": 5020,
                    "finalizadas": 15771,
                    "canceladas": 2633,
                    "indeferidas": 7956,
                    "deferidas": 7815,
                    "media_atendimento_dias": 731.33992327788
                },
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 20715,
                    "abertas": 775,
                    "finalizadas": 19840,
                    "canceladas": 78,
                    "indeferidas": 5188,
                    "deferidas": 14652,
                    "media_atendimento_dias": 105.25575275007
                },
                {
                    "servico_id": 538,
                    "servico_desc": "Serviço Especializado de Abordagem Social às Pessoas em Situação de Rua - SEAS",
                    "total": 11765,
                    "abertas": 19,
                    "finalizadas": 11589,
                    "canceladas": 123,
                    "indeferidas": 602,
                    "deferidas": 10987,
                    "media_atendimento_dias": 57.832424252863
                },
                {
                    "servico_id": 520,
                    "servico_desc": "Reparo de lâmpada",
                    "total": 8829,
                    "abertas": 14,
                    "finalizadas": 8784,
                    "canceladas": 24,
                    "indeferidas": 6560,
                    "deferidas": 2224,
                    "media_atendimento_dias": 509.85070117864
                },
                {
                    "servico_id": 483,
                    "servico_desc": "Reclamação de poluição sonora - PSIU",
                    "total": 5424,
                    "abertas": 1156,
                    "finalizadas": 4113,
                    "canceladas": 135,
                    "indeferidas": 203,
                    "deferidas": 3910,
                    "media_atendimento_dias": 206.56389162108
                }
            ],
            "media_atendimento_dias": 269.91
        },
        {
            "id": 14,
            "nome": "SE",
            "total": 364270,
            "abertas": 19796,
            "finalizadas": 337011,
            "canceladas": 6772,
            "indeferidas": 86009,
            "deferidas": 251002,
            "servicos": [
                {
                    "servico_id": 538,
                    "servico_desc": "Serviço Especializado de Abordagem Social às Pessoas em Situação de Rua - SEAS",
                    "total": 105487,
                    "abertas": 156,
                    "finalizadas": 103451,
                    "canceladas": 1467,
                    "indeferidas": 7527,
                    "deferidas": 95924,
                    "media_atendimento_dias": 79.288205456852
                },
                {
                    "servico_id": 585,
                    "servico_desc": "Vistas de processos",
                    "total": 21780,
                    "abertas": 1,
                    "finalizadas": 21211,
                    "canceladas": 568,
                    "indeferidas": 19828,
                    "deferidas": 1383,
                    "media_atendimento_dias": 104.85561340082
                },
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 20945,
                    "abertas": 558,
                    "finalizadas": 20224,
                    "canceladas": 152,
                    "indeferidas": 3789,
                    "deferidas": 16435,
                    "media_atendimento_dias": 117.92756875993
                },
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 18196,
                    "abertas": 3319,
                    "finalizadas": 12290,
                    "canceladas": 2483,
                    "indeferidas": 6446,
                    "deferidas": 5844,
                    "media_atendimento_dias": 490.0674951537
                },
                {
                    "servico_id": 483,
                    "servico_desc": "Reclamação de poluição sonora - PSIU",
                    "total": 10865,
                    "abertas": 1674,
                    "finalizadas": 8865,
                    "canceladas": 301,
                    "indeferidas": 188,
                    "deferidas": 8677,
                    "media_atendimento_dias": 245.1950380916
                }
            ],
            "media_atendimento_dias": 229.45
        },
        {
            "id": 15,
            "nome": "MOOCA",
            "total": 252173,
            "abertas": 19441,
            "finalizadas": 225741,
            "canceladas": 6420,
            "indeferidas": 34277,
            "deferidas": 191464,
            "servicos": [
                {
                    "servico_id": 538,
                    "servico_desc": "Serviço Especializado de Abordagem Social às Pessoas em Situação de Rua - SEAS",
                    "total": 84549,
                    "abertas": 419,
                    "finalizadas": 82407,
                    "canceladas": 1399,
                    "indeferidas": 4303,
                    "deferidas": 78104,
                    "media_atendimento_dias": 61.594252797078
                },
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 22318,
                    "abertas": 1648,
                    "finalizadas": 19245,
                    "canceladas": 1403,
                    "indeferidas": 4488,
                    "deferidas": 14757,
                    "media_atendimento_dias": 81.573900246493
                },
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 12995,
                    "abertas": 3069,
                    "finalizadas": 8534,
                    "canceladas": 1357,
                    "indeferidas": 3214,
                    "deferidas": 5320,
                    "media_atendimento_dias": 215.96971210143
                },
                {
                    "servico_id": 516,
                    "servico_desc": "Remoção de veículo/carcaça abandonado na via pública",
                    "total": 8761,
                    "abertas": 1245,
                    "finalizadas": 7283,
                    "canceladas": 224,
                    "indeferidas": 512,
                    "deferidas": 6771,
                    "media_atendimento_dias": 407.29652812649
                },
                {
                    "servico_id": 483,
                    "servico_desc": "Reclamação de poluição sonora - PSIU",
                    "total": 8008,
                    "abertas": 909,
                    "finalizadas": 6751,
                    "canceladas": 331,
                    "indeferidas": 47,
                    "deferidas": 6704,
                    "media_atendimento_dias": 199.02498660625
                }
            ],
            "media_atendimento_dias": 182.06
        },
        {
            "id": 16,
            "nome": "ARICANDUVA-FORMOSA-CARRAO",
            "total": 98590,
            "abertas": 10099,
            "finalizadas": 84469,
            "canceladas": 3924,
            "indeferidas": 17188,
            "deferidas": 67281,
            "servicos": [
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 10893,
                    "abertas": 306,
                    "finalizadas": 9835,
                    "canceladas": 747,
                    "indeferidas": 2093,
                    "deferidas": 7742,
                    "media_atendimento_dias": 72.498639147818
                },
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 8944,
                    "abertas": 2163,
                    "finalizadas": 5174,
                    "canceladas": 1580,
                    "indeferidas": 622,
                    "deferidas": 4552,
                    "media_atendimento_dias": 420.39069545641
                },
                {
                    "servico_id": 516,
                    "servico_desc": "Remoção de veículo/carcaça abandonado na via pública",
                    "total": 7639,
                    "abertas": 2157,
                    "finalizadas": 5374,
                    "canceladas": 105,
                    "indeferidas": 120,
                    "deferidas": 5254,
                    "media_atendimento_dias": 337.89854860142
                },
                {
                    "servico_id": 520,
                    "servico_desc": "Reparo de lâmpada",
                    "total": 5049,
                    "abertas": 14,
                    "finalizadas": 5018,
                    "canceladas": 13,
                    "indeferidas": 4119,
                    "deferidas": 899,
                    "media_atendimento_dias": 398.77839704868
                },
                {
                    "servico_id": 538,
                    "servico_desc": "Serviço Especializado de Abordagem Social às Pessoas em Situação de Rua - SEAS",
                    "total": 4208,
                    "abertas": 4,
                    "finalizadas": 4126,
                    "canceladas": 66,
                    "indeferidas": 155,
                    "deferidas": 3971,
                    "media_atendimento_dias": 62.25596012934
                }
            ],
            "media_atendimento_dias": 212.08
        },
        {
            "id": 17,
            "nome": "SAO MATEUS",
            "total": 117619,
            "abertas": 11230,
            "finalizadas": 104958,
            "canceladas": 1213,
            "indeferidas": 42820,
            "deferidas": 62138,
            "servicos": [
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 17044,
                    "abertas": 582,
                    "finalizadas": 16231,
                    "canceladas": 221,
                    "indeferidas": 7969,
                    "deferidas": 8262,
                    "media_atendimento_dias": 57.77978592726
                },
                {
                    "servico_id": 520,
                    "servico_desc": "Reparo de lâmpada",
                    "total": 11083,
                    "abertas": 5,
                    "finalizadas": 11072,
                    "canceladas": 4,
                    "indeferidas": 9998,
                    "deferidas": 1074,
                    "media_atendimento_dias": 410.37815470032
                },
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 10093,
                    "abertas": 2013,
                    "finalizadas": 7744,
                    "canceladas": 250,
                    "indeferidas": 5011,
                    "deferidas": 2733,
                    "media_atendimento_dias": 798.93861631584
                },
                {
                    "servico_id": 530,
                    "servico_desc": "Roçada em praças e canteiro central",
                    "total": 6308,
                    "abertas": 178,
                    "finalizadas": 6105,
                    "canceladas": 19,
                    "indeferidas": 2938,
                    "deferidas": 3167,
                    "media_atendimento_dias": 561.15799814932
                },
                {
                    "servico_id": 278,
                    "servico_desc": "Fiscalização de descarte irregular de entulho e outros resíduos em área pública",
                    "total": 3376,
                    "abertas": 1031,
                    "finalizadas": 2293,
                    "canceladas": 19,
                    "indeferidas": 462,
                    "deferidas": 1831,
                    "media_atendimento_dias": 630.28116300797
                }
            ],
            "media_atendimento_dias": 347.73
        },
        {
            "id": 18,
            "nome": "VILA PRUDENTE",
            "total": 83204,
            "abertas": 6708,
            "finalizadas": 73698,
            "canceladas": 2713,
            "indeferidas": 17036,
            "deferidas": 56662,
            "servicos": [
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 10122,
                    "abertas": 854,
                    "finalizadas": 8913,
                    "canceladas": 346,
                    "indeferidas": 3186,
                    "deferidas": 5727,
                    "media_atendimento_dias": 79.446108728392
                },
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 8269,
                    "abertas": 1900,
                    "finalizadas": 5042,
                    "canceladas": 1316,
                    "indeferidas": 1626,
                    "deferidas": 3416,
                    "media_atendimento_dias": 336.37932553574
                },
                {
                    "servico_id": 538,
                    "servico_desc": "Serviço Especializado de Abordagem Social às Pessoas em Situação de Rua - SEAS",
                    "total": 6643,
                    "abertas": 13,
                    "finalizadas": 6526,
                    "canceladas": 80,
                    "indeferidas": 326,
                    "deferidas": 6200,
                    "media_atendimento_dias": 32.808161295923
                },
                {
                    "servico_id": 520,
                    "servico_desc": "Reparo de lâmpada",
                    "total": 4731,
                    "abertas": 17,
                    "finalizadas": 4704,
                    "canceladas": 6,
                    "indeferidas": 3693,
                    "deferidas": 1011,
                    "media_atendimento_dias": 358.96291919671
                },
                {
                    "servico_id": 516,
                    "servico_desc": "Remoção de veículo/carcaça abandonado na via pública",
                    "total": 3842,
                    "abertas": 967,
                    "finalizadas": 2829,
                    "canceladas": 43,
                    "indeferidas": 12,
                    "deferidas": 2817,
                    "media_atendimento_dias": 328.03049894654
                }
            ],
            "media_atendimento_dias": 182.97
        },
        {
            "id": 19,
            "nome": "IPIRANGA",
            "total": 166945,
            "abertas": 15673,
            "finalizadas": 146226,
            "canceladas": 4674,
            "indeferidas": 34409,
            "deferidas": 111817,
            "servicos": [
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 25937,
                    "abertas": 1735,
                    "finalizadas": 23685,
                    "canceladas": 504,
                    "indeferidas": 3777,
                    "deferidas": 19908,
                    "media_atendimento_dias": 145.40879391148
                },
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 16912,
                    "abertas": 5611,
                    "finalizadas": 9103,
                    "canceladas": 1948,
                    "indeferidas": 1812,
                    "deferidas": 7291,
                    "media_atendimento_dias": 657.26102773523
                },
                {
                    "servico_id": 520,
                    "servico_desc": "Reparo de lâmpada",
                    "total": 9955,
                    "abertas": 10,
                    "finalizadas": 9921,
                    "canceladas": 18,
                    "indeferidas": 8871,
                    "deferidas": 1050,
                    "media_atendimento_dias": 349.23484448854
                },
                {
                    "servico_id": 516,
                    "servico_desc": "Remoção de veículo/carcaça abandonado na via pública",
                    "total": 9259,
                    "abertas": 712,
                    "finalizadas": 8271,
                    "canceladas": 275,
                    "indeferidas": 1448,
                    "deferidas": 6823,
                    "media_atendimento_dias": 462.68608257541
                },
                {
                    "servico_id": 513,
                    "servico_desc": "Remoção de grandes objetos em vias públicas",
                    "total": 5511,
                    "abertas": 287,
                    "finalizadas": 5091,
                    "canceladas": 131,
                    "indeferidas": 2,
                    "deferidas": 5089,
                    "media_atendimento_dias": 58.469466180233
                }
            ],
            "media_atendimento_dias": 250.96
        },
        {
            "id": 20,
            "nome": "VILA MARIANA",
            "total": 135487,
            "abertas": 13753,
            "finalizadas": 118527,
            "canceladas": 3017,
            "indeferidas": 26565,
            "deferidas": 91962,
            "servicos": [
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 18302,
                    "abertas": 3524,
                    "finalizadas": 13688,
                    "canceladas": 1037,
                    "indeferidas": 4056,
                    "deferidas": 9632,
                    "media_atendimento_dias": 565.93567991076
                },
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 12364,
                    "abertas": 838,
                    "finalizadas": 11204,
                    "canceladas": 318,
                    "indeferidas": 991,
                    "deferidas": 10213,
                    "media_atendimento_dias": 58.517795140589
                },
                {
                    "servico_id": 520,
                    "servico_desc": "Reparo de lâmpada",
                    "total": 7414,
                    "abertas": 7,
                    "finalizadas": 7392,
                    "canceladas": 14,
                    "indeferidas": 6495,
                    "deferidas": 897,
                    "media_atendimento_dias": 470.97119086513
                },
                {
                    "servico_id": 538,
                    "servico_desc": "Serviço Especializado de Abordagem Social às Pessoas em Situação de Rua - SEAS",
                    "total": 6967,
                    "abertas": 2,
                    "finalizadas": 6888,
                    "canceladas": 48,
                    "indeferidas": 379,
                    "deferidas": 6509,
                    "media_atendimento_dias": 73.750079103435
                },
                {
                    "servico_id": 516,
                    "servico_desc": "Remoção de veículo/carcaça abandonado na via pública",
                    "total": 5798,
                    "abertas": 1262,
                    "finalizadas": 4418,
                    "canceladas": 115,
                    "indeferidas": 321,
                    "deferidas": 4097,
                    "media_atendimento_dias": 401.24276881401
                }
            ],
            "media_atendimento_dias": 268.94
        },
        {
            "id": 21,
            "nome": "BUTANTA",
            "total": 171296,
            "abertas": 13913,
            "finalizadas": 147047,
            "canceladas": 10167,
            "indeferidas": 32976,
            "deferidas": 114071,
            "servicos": [
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 17810,
                    "abertas": 352,
                    "finalizadas": 17375,
                    "canceladas": 66,
                    "indeferidas": 3353,
                    "deferidas": 14022,
                    "media_atendimento_dias": 70.02016970191
                },
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 17807,
                    "abertas": 1379,
                    "finalizadas": 13457,
                    "canceladas": 2948,
                    "indeferidas": 4631,
                    "deferidas": 8826,
                    "media_atendimento_dias": 307.63041962247
                },
                {
                    "servico_id": 516,
                    "servico_desc": "Remoção de veículo/carcaça abandonado na via pública",
                    "total": 7682,
                    "abertas": 1434,
                    "finalizadas": 6108,
                    "canceladas": 136,
                    "indeferidas": 207,
                    "deferidas": 5901,
                    "media_atendimento_dias": 905.94143032098
                },
                {
                    "servico_id": 520,
                    "servico_desc": "Reparo de lâmpada",
                    "total": 6996,
                    "abertas": 17,
                    "finalizadas": 6937,
                    "canceladas": 35,
                    "indeferidas": 4119,
                    "deferidas": 2818,
                    "media_atendimento_dias": 575.14777528471
                },
                {
                    "servico_id": 530,
                    "servico_desc": "Roçada em praças e canteiro central",
                    "total": 6676,
                    "abertas": 234,
                    "finalizadas": 5030,
                    "canceladas": 1409,
                    "indeferidas": 1243,
                    "deferidas": 3787,
                    "media_atendimento_dias": 90.750904590143
                }
            ],
            "media_atendimento_dias": 362.06
        },
        {
            "id": 22,
            "nome": "PINHEIROS",
            "total": 166417,
            "abertas": 18482,
            "finalizadas": 142417,
            "canceladas": 5278,
            "indeferidas": 31238,
            "deferidas": 111179,
            "servicos": [
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 20534,
                    "abertas": 5388,
                    "finalizadas": 12697,
                    "canceladas": 2350,
                    "indeferidas": 2628,
                    "deferidas": 10069,
                    "media_atendimento_dias": 661.06606282507
                },
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 17234,
                    "abertas": 506,
                    "finalizadas": 15558,
                    "canceladas": 1156,
                    "indeferidas": 5295,
                    "deferidas": 10263,
                    "media_atendimento_dias": 155.15581644757
                },
                {
                    "servico_id": 483,
                    "servico_desc": "Reclamação de poluição sonora - PSIU",
                    "total": 10253,
                    "abertas": 1610,
                    "finalizadas": 8491,
                    "canceladas": 126,
                    "indeferidas": 261,
                    "deferidas": 8230,
                    "media_atendimento_dias": 211.31931850783
                },
                {
                    "servico_id": 520,
                    "servico_desc": "Reparo de lâmpada",
                    "total": 7864,
                    "abertas": 13,
                    "finalizadas": 7823,
                    "canceladas": 23,
                    "indeferidas": 6117,
                    "deferidas": 1706,
                    "media_atendimento_dias": 351.2007413649
                },
                {
                    "servico_id": 538,
                    "servico_desc": "Serviço Especializado de Abordagem Social às Pessoas em Situação de Rua - SEAS",
                    "total": 7296,
                    "abertas": 4,
                    "finalizadas": 7173,
                    "canceladas": 79,
                    "indeferidas": 501,
                    "deferidas": 6672,
                    "media_atendimento_dias": 73.343560264636
                }
            ],
            "media_atendimento_dias": 306.04
        },
        {
            "id": 23,
            "nome": "CAMPO LIMPO",
            "total": 146292,
            "abertas": 16310,
            "finalizadas": 126796,
            "canceladas": 2954,
            "indeferidas": 33754,
            "deferidas": 93042,
            "servicos": [
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 15934,
                    "abertas": 957,
                    "finalizadas": 14883,
                    "canceladas": 77,
                    "indeferidas": 2761,
                    "deferidas": 12122,
                    "media_atendimento_dias": 104.33044852831
                },
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 13304,
                    "abertas": 3137,
                    "finalizadas": 8921,
                    "canceladas": 1171,
                    "indeferidas": 4526,
                    "deferidas": 4395,
                    "media_atendimento_dias": 657.64935014537
                },
                {
                    "servico_id": 516,
                    "servico_desc": "Remoção de veículo/carcaça abandonado na via pública",
                    "total": 6699,
                    "abertas": 2205,
                    "finalizadas": 4298,
                    "canceladas": 193,
                    "indeferidas": 746,
                    "deferidas": 3552,
                    "media_atendimento_dias": 707.3609355547
                },
                {
                    "servico_id": 520,
                    "servico_desc": "Reparo de lâmpada",
                    "total": 5046,
                    "abertas": 13,
                    "finalizadas": 5011,
                    "canceladas": 13,
                    "indeferidas": 3586,
                    "deferidas": 1425,
                    "media_atendimento_dias": 504.0760655783
                },
                {
                    "servico_id": 279,
                    "servico_desc": "Fiscalização de estabelecimentos comerciais e serviços",
                    "total": 4994,
                    "abertas": 687,
                    "finalizadas": 4263,
                    "canceladas": 42,
                    "indeferidas": 2167,
                    "deferidas": 2096,
                    "media_atendimento_dias": 1042.3875867062
                }
            ],
            "media_atendimento_dias": 293.73
        },
        {
            "id": 24,
            "nome": "M'BOI MIRIM",
            "total": 135398,
            "abertas": 12331,
            "finalizadas": 120701,
            "canceladas": 2208,
            "indeferidas": 40168,
            "deferidas": 80533,
            "servicos": [
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 28025,
                    "abertas": 1421,
                    "finalizadas": 26417,
                    "canceladas": 177,
                    "indeferidas": 10913,
                    "deferidas": 15504,
                    "media_atendimento_dias": 222.39739577958
                },
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 10486,
                    "abertas": 906,
                    "finalizadas": 8739,
                    "canceladas": 825,
                    "indeferidas": 5945,
                    "deferidas": 2794,
                    "media_atendimento_dias": 329.50373777556
                },
                {
                    "servico_id": 520,
                    "servico_desc": "Reparo de lâmpada",
                    "total": 4724,
                    "abertas": 2,
                    "finalizadas": 4699,
                    "canceladas": 13,
                    "indeferidas": 3649,
                    "deferidas": 1050,
                    "media_atendimento_dias": 512.55267095459
                },
                {
                    "servico_id": 516,
                    "servico_desc": "Remoção de veículo/carcaça abandonado na via pública",
                    "total": 4181,
                    "abertas": 1973,
                    "finalizadas": 2098,
                    "canceladas": 97,
                    "indeferidas": 192,
                    "deferidas": 1906,
                    "media_atendimento_dias": 757.32089270967
                },
                {
                    "servico_id": 278,
                    "servico_desc": "Fiscalização de descarte irregular de entulho e outros resíduos em área pública",
                    "total": 3903,
                    "abertas": 522,
                    "finalizadas": 3292,
                    "canceladas": 85,
                    "indeferidas": 1374,
                    "deferidas": 1918,
                    "media_atendimento_dias": 280.87835169616
                }
            ],
            "media_atendimento_dias": 286.06
        },
        {
            "id": 25,
            "nome": "CAPELA DO SOCORRO",
            "total": 138205,
            "abertas": 10305,
            "finalizadas": 126358,
            "canceladas": 1412,
            "indeferidas": 30201,
            "deferidas": 96157,
            "servicos": [
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 18929,
                    "abertas": 567,
                    "finalizadas": 18192,
                    "canceladas": 152,
                    "indeferidas": 3392,
                    "deferidas": 14800,
                    "media_atendimento_dias": 119.79291554523
                },
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 9148,
                    "abertas": 335,
                    "finalizadas": 8747,
                    "canceladas": 60,
                    "indeferidas": 5014,
                    "deferidas": 3733,
                    "media_atendimento_dias": 251.80602542638
                },
                {
                    "servico_id": 520,
                    "servico_desc": "Reparo de lâmpada",
                    "total": 5234,
                    "abertas": 14,
                    "finalizadas": 5203,
                    "canceladas": 13,
                    "indeferidas": 3644,
                    "deferidas": 1559,
                    "media_atendimento_dias": 517.95663162521
                },
                {
                    "servico_id": 516,
                    "servico_desc": "Remoção de veículo/carcaça abandonado na via pública",
                    "total": 4805,
                    "abertas": 1839,
                    "finalizadas": 2867,
                    "canceladas": 85,
                    "indeferidas": 37,
                    "deferidas": 2830,
                    "media_atendimento_dias": 935.44813335133
                },
                {
                    "servico_id": 530,
                    "servico_desc": "Roçada em praças e canteiro central",
                    "total": 4580,
                    "abertas": 113,
                    "finalizadas": 4438,
                    "canceladas": 26,
                    "indeferidas": 1080,
                    "deferidas": 3358,
                    "media_atendimento_dias": 176.34567851372
                }
            ],
            "media_atendimento_dias": 305.84
        },
        {
            "id": 26,
            "nome": "CIDADE ADEMAR",
            "total": 101100,
            "abertas": 9798,
            "finalizadas": 86586,
            "canceladas": 4623,
            "indeferidas": 26453,
            "deferidas": 60133,
            "servicos": [
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 8601,
                    "abertas": 451,
                    "finalizadas": 7165,
                    "canceladas": 974,
                    "indeferidas": 2778,
                    "deferidas": 4387,
                    "media_atendimento_dias": 58.098388320079
                },
                {
                    "servico_id": 520,
                    "servico_desc": "Reparo de lâmpada",
                    "total": 8131,
                    "abertas": 4,
                    "finalizadas": 8119,
                    "canceladas": 7,
                    "indeferidas": 7422,
                    "deferidas": 697,
                    "media_atendimento_dias": 382.19969410901
                },
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 8065,
                    "abertas": 1371,
                    "finalizadas": 5075,
                    "canceladas": 1611,
                    "indeferidas": 1629,
                    "deferidas": 3446,
                    "media_atendimento_dias": 360.14240618484
                },
                {
                    "servico_id": 516,
                    "servico_desc": "Remoção de veículo/carcaça abandonado na via pública",
                    "total": 4648,
                    "abertas": 1619,
                    "finalizadas": 2892,
                    "canceladas": 129,
                    "indeferidas": 325,
                    "deferidas": 2567,
                    "media_atendimento_dias": 807.46831561377
                },
                {
                    "servico_id": 279,
                    "servico_desc": "Fiscalização de estabelecimentos comerciais e serviços",
                    "total": 3362,
                    "abertas": 418,
                    "finalizadas": 2897,
                    "canceladas": 46,
                    "indeferidas": 1280,
                    "deferidas": 1617,
                    "media_atendimento_dias": 1270.6671243114
                }
            ],
            "media_atendimento_dias": 299.13
        },
        {
            "id": 27,
            "nome": "PARELHEIROS",
            "total": 25594,
            "abertas": 2549,
            "finalizadas": 22542,
            "canceladas": 468,
            "indeferidas": 5604,
            "deferidas": 16938,
            "servicos": [
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 3234,
                    "abertas": 256,
                    "finalizadas": 2875,
                    "canceladas": 97,
                    "indeferidas": 331,
                    "deferidas": 2544,
                    "media_atendimento_dias": 188.72389367047
                },
                {
                    "servico_id": 366,
                    "servico_desc": "Nivelamento de vias de terra",
                    "total": 1533,
                    "abertas": 553,
                    "finalizadas": 953,
                    "canceladas": 21,
                    "indeferidas": 351,
                    "deferidas": 602,
                    "media_atendimento_dias": 195.61692587209
                },
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 1250,
                    "abertas": 222,
                    "finalizadas": 989,
                    "canceladas": 37,
                    "indeferidas": 308,
                    "deferidas": 681,
                    "media_atendimento_dias": 387.18766254691
                },
                {
                    "servico_id": 449,
                    "servico_desc": "Recapeamento",
                    "total": 1042,
                    "abertas": 0,
                    "finalizadas": 1038,
                    "canceladas": 4,
                    "indeferidas": 462,
                    "deferidas": 576,
                    "media_atendimento_dias": 427.20030520592
                },
                {
                    "servico_id": 395,
                    "servico_desc": "Pavimentação de ruas não asfaltadas",
                    "total": 990,
                    "abertas": 0,
                    "finalizadas": 987,
                    "canceladas": 3,
                    "indeferidas": 655,
                    "deferidas": 332,
                    "media_atendimento_dias": 506.54683320086
                }
            ],
            "media_atendimento_dias": 277.66
        },
        {
            "id": 28,
            "nome": "JABAQUARA",
            "total": 87408,
            "abertas": 4120,
            "finalizadas": 81278,
            "canceladas": 1911,
            "indeferidas": 27000,
            "deferidas": 54278,
            "servicos": [
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 10937,
                    "abertas": 247,
                    "finalizadas": 10593,
                    "canceladas": 90,
                    "indeferidas": 4754,
                    "deferidas": 5839,
                    "media_atendimento_dias": 93.213644336771
                },
                {
                    "servico_id": 538,
                    "servico_desc": "Serviço Especializado de Abordagem Social às Pessoas em Situação de Rua - SEAS",
                    "total": 9833,
                    "abertas": 2,
                    "finalizadas": 9465,
                    "canceladas": 333,
                    "indeferidas": 954,
                    "deferidas": 8511,
                    "media_atendimento_dias": 62.556890627924
                },
                {
                    "servico_id": 520,
                    "servico_desc": "Reparo de lâmpada",
                    "total": 8034,
                    "abertas": 3,
                    "finalizadas": 8025,
                    "canceladas": 5,
                    "indeferidas": 7458,
                    "deferidas": 567,
                    "media_atendimento_dias": 320.69657536008
                },
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 7791,
                    "abertas": 683,
                    "finalizadas": 6199,
                    "canceladas": 883,
                    "indeferidas": 2977,
                    "deferidas": 3222,
                    "media_atendimento_dias": 308.69271748267
                },
                {
                    "servico_id": 516,
                    "servico_desc": "Remoção de veículo/carcaça abandonado na via pública",
                    "total": 2941,
                    "abertas": 306,
                    "finalizadas": 2608,
                    "canceladas": 27,
                    "indeferidas": 87,
                    "deferidas": 2521,
                    "media_atendimento_dias": 286.76571638514
                }
            ],
            "media_atendimento_dias": 226.2
        },
        {
            "id": 29,
            "nome": "SANTO AMARO",
            "total": 159178,
            "abertas": 13286,
            "finalizadas": 139515,
            "canceladas": 6107,
            "indeferidas": 29408,
            "deferidas": 110107,
            "servicos": [
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 23496,
                    "abertas": 1200,
                    "finalizadas": 20887,
                    "canceladas": 1385,
                    "indeferidas": 1866,
                    "deferidas": 19021,
                    "media_atendimento_dias": 110.0886486622
                },
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 15716,
                    "abertas": 3673,
                    "finalizadas": 8726,
                    "canceladas": 3170,
                    "indeferidas": 1156,
                    "deferidas": 7570,
                    "media_atendimento_dias": 347.59086550223
                },
                {
                    "servico_id": 292,
                    "servico_desc": "Fiscalização de veículo estacionado/parado em local proibido",
                    "total": 12276,
                    "abertas": 64,
                    "finalizadas": 12188,
                    "canceladas": 23,
                    "indeferidas": 6097,
                    "deferidas": 6091,
                    "media_atendimento_dias": 120.22172340832
                },
                {
                    "servico_id": 520,
                    "servico_desc": "Reparo de lâmpada",
                    "total": 8392,
                    "abertas": 6,
                    "finalizadas": 8373,
                    "canceladas": 12,
                    "indeferidas": 7607,
                    "deferidas": 766,
                    "media_atendimento_dias": 369.84839629569
                },
                {
                    "servico_id": 538,
                    "servico_desc": "Serviço Especializado de Abordagem Social às Pessoas em Situação de Rua - SEAS",
                    "total": 6506,
                    "abertas": 3,
                    "finalizadas": 6396,
                    "canceladas": 79,
                    "indeferidas": 434,
                    "deferidas": 5962,
                    "media_atendimento_dias": 61.690125476397
                }
            ],
            "media_atendimento_dias": 227.71
        },
        {
            "id": 30,
            "nome": "CIDADE TIRADENTES",
            "total": 24132,
            "abertas": 2339,
            "finalizadas": 21487,
            "canceladas": 272,
            "indeferidas": 6625,
            "deferidas": 14862,
            "servicos": [
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 1806,
                    "abertas": 56,
                    "finalizadas": 1732,
                    "canceladas": 16,
                    "indeferidas": 644,
                    "deferidas": 1088,
                    "media_atendimento_dias": 83.05211035369
                },
                {
                    "servico_id": 520,
                    "servico_desc": "Reparo de lâmpada",
                    "total": 1742,
                    "abertas": 1,
                    "finalizadas": 1739,
                    "canceladas": 1,
                    "indeferidas": 1592,
                    "deferidas": 147,
                    "media_atendimento_dias": 299.84557823129
                },
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 1381,
                    "abertas": 221,
                    "finalizadas": 1143,
                    "canceladas": 14,
                    "indeferidas": 416,
                    "deferidas": 727,
                    "media_atendimento_dias": 124.41223930473
                },
                {
                    "servico_id": 530,
                    "servico_desc": "Roçada em praças e canteiro central",
                    "total": 1196,
                    "abertas": 173,
                    "finalizadas": 1008,
                    "canceladas": 13,
                    "indeferidas": 142,
                    "deferidas": 866,
                    "media_atendimento_dias": 96.441867021106
                },
                {
                    "servico_id": 483,
                    "servico_desc": "Reclamação de poluição sonora - PSIU",
                    "total": 690,
                    "abertas": 200,
                    "finalizadas": 465,
                    "canceladas": 22,
                    "indeferidas": 28,
                    "deferidas": 437,
                    "media_atendimento_dias": 249.11661886071
                }
            ],
            "media_atendimento_dias": 142.06
        },
        {
            "id": 31,
            "nome": "PERUS",
            "total": 25108,
            "abertas": 1504,
            "finalizadas": 22926,
            "canceladas": 661,
            "indeferidas": 6364,
            "deferidas": 16562,
            "servicos": [
                {
                    "servico_id": 520,
                    "servico_desc": "Reparo de lâmpada",
                    "total": 3368,
                    "abertas": 0,
                    "finalizadas": 3365,
                    "canceladas": 3,
                    "indeferidas": 3088,
                    "deferidas": 277,
                    "media_atendimento_dias": 412.66051686389
                },
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 2119,
                    "abertas": 135,
                    "finalizadas": 1812,
                    "canceladas": 169,
                    "indeferidas": 595,
                    "deferidas": 1217,
                    "media_atendimento_dias": 136.40795165518
                },
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 1544,
                    "abertas": 31,
                    "finalizadas": 1481,
                    "canceladas": 31,
                    "indeferidas": 192,
                    "deferidas": 1289,
                    "media_atendimento_dias": 58.2395248883
                },
                {
                    "servico_id": 385,
                    "servico_desc": "Ônibus - Reclamação de intervalo excessivo da linha",
                    "total": 927,
                    "abertas": 11,
                    "finalizadas": 913,
                    "canceladas": 3,
                    "indeferidas": 3,
                    "deferidas": 910,
                    "media_atendimento_dias": 12.928544083232
                },
                {
                    "servico_id": 516,
                    "servico_desc": "Remoção de veículo/carcaça abandonado na via pública",
                    "total": 895,
                    "abertas": 118,
                    "finalizadas": 761,
                    "canceladas": 13,
                    "indeferidas": 9,
                    "deferidas": 752,
                    "media_atendimento_dias": 401.42338572449
                }
            ],
            "media_atendimento_dias": 200.45
        },
        {
            "id": 32,
            "nome": "SAPOPEMBA",
            "total": 61962,
            "abertas": 4973,
            "finalizadas": 54212,
            "canceladas": 2734,
            "indeferidas": 11358,
            "deferidas": 42854,
            "servicos": [
                {
                    "servico_id": 557,
                    "servico_desc": "Tapa-buraco",
                    "total": 11355,
                    "abertas": 44,
                    "finalizadas": 10009,
                    "canceladas": 1301,
                    "indeferidas": 1804,
                    "deferidas": 8205,
                    "media_atendimento_dias": 108.58880648656
                },
                {
                    "servico_id": 42,
                    "servico_desc": "Avaliação e serviços em árvore em área pública",
                    "total": 6056,
                    "abertas": 902,
                    "finalizadas": 4593,
                    "canceladas": 556,
                    "indeferidas": 1041,
                    "deferidas": 3552,
                    "media_atendimento_dias": 744.42550776362
                },
                {
                    "servico_id": 520,
                    "servico_desc": "Reparo de lâmpada",
                    "total": 2883,
                    "abertas": 5,
                    "finalizadas": 2872,
                    "canceladas": 6,
                    "indeferidas": 2402,
                    "deferidas": 470,
                    "media_atendimento_dias": 412.26326182033
                },
                {
                    "servico_id": 516,
                    "servico_desc": "Remoção de veículo/carcaça abandonado na via pública",
                    "total": 2364,
                    "abertas": 414,
                    "finalizadas": 1925,
                    "canceladas": 23,
                    "indeferidas": 16,
                    "deferidas": 1909,
                    "media_atendimento_dias": 393.34495150893
                },
                {
                    "servico_id": 530,
                    "servico_desc": "Roçada em praças e canteiro central",
                    "total": 2071,
                    "abertas": 75,
                    "finalizadas": 1915,
                    "canceladas": 79,
                    "indeferidas": 324,
                    "deferidas": 1591,
                    "media_atendimento_dias": 357.34432572107
                }
            ],
            "media_atendimento_dias": 273.62
        }
    ]
}

export default {
    getTotais,
    mapaDeCalor,
    calcularMapa,
    RECURSO,
    subs: [],

    totais: 0,
    solicitacoesMinima: {
        id: 0,
        valor: 0
    },
    solicitacoesMaxima: {
        id: 0,
        valor: 0
    },

    abertas: 0,
    solicitacoesAbertasMinima: {
        id: 0,
        valor: 0
    },
    solicitacoesAbertasMaxima: {
        id: 0,
        valor: 0
    },

    finalizadas: 0,
    solicitacoesfinalizadasMinima: {
        id: 0,
        valor: 0
    },
    solicitacoesfinalizadasMaxima: {
        id: 0,
        valor: 0
    },

    canceladas: 0,
    solicitacoescanceladasMinima: {
        id: 0,
        valor: 0
    },
    solicitacoescanceladasMaxima: {
        id: 0,
        valor: 0
    },

    indeferidas: 0,
    solicitacoesindeferidasMinima: {
        id: 0,
        valor: 0
    },
    solicitacoesindeferidasMaxima: {
        id: 0,
        valor: 0
    },

    deferidas: 0,
    solicitacoesdeferidasMinima: {
        id: 0,
        valor: 0
    },
    solicitacoesdeferidasMaxima: {
        id: 0,
        valor: 0
    },

    media_atendimento_dias: 0,
    solicitacoesMDAMinima: {
        id: 0,
        valor: 0
    },
    solicitacoesMDAMaxima: {
        id: 0,
        valor: 0
    }

};

function getTotais () {
    RECURSO.data.forEach((element) => {
        this.subs[element.id] = element;
        this.totais = +element.total;
        this.deferidas = +element.deferidas;
        this.canceladas = +element.canceladas;
        this.indeferidas = +element.indeferidas;
        this.finalizadas = +element.finalizadas;
        this.abertas = +element.abertas;

        this.solicitacoesMinima = rumble({
            'id': element.id,
            'valor': element.total
        }, this.solicitacoesMinima, -1);
        this.solicitacoesMaxima = rumble({
            'id': element.id,
            'valor': element.total
        }, this.solicitacoesMaxima);

        this.solicitacoesAbertasMinima = rumble({
            'id': element.id,
            'valor': element.abertas
        }, this.solicitacoesAbertasMinima, -1);
        this.solicitacoesAbertasMaxima = rumble({
            'id': element.id,
            'valor': element.abertas
        }, this.solicitacoesAbertasMaxima);

        this.solicitacoesfinalizadasMinima = rumble({
            'id': element.id,
            'valor': element.finalizadas
        }, this.solicitacoesfinalizadasMinima, -1);
        this.solicitacoesfinalizadasMaxima = rumble({
            'id': element.id,
            'valor': element.finalizadas
        }, this.solicitacoesfinalizadasMaxima);

        this.solicitacoescanceladasMinima = rumble({
            'id': element.id,
            'valor': element.canceladas
        }, this.solicitacoescanceladasMinima, -1);
        this.solicitacoescanceladasMaxima = rumble({
            'id': element.id,
            'valor': element.canceladas
        }, this.solicitacoescanceladasMaxima);

        this.solicitacoesindeferidasMinima = rumble({
            'id': element.id,
            'valor': element.deferidas
        }, this.solicitacoesindeferidasMinima, -1);
        this.solicitacoesindeferidasMaxima = rumble({
            'id': element.id,
            'valor': element.deferidas
        }, this.solicitacoesindeferidasMaxima);

        this.solicitacoesdeferidasMinima = rumble({
            'id': element.id,
            'valor': element.indeferidas
        }, this.solicitacoesdeferidasMinima, -1);
        this.solicitacoesdeferidasMaxima = rumble({
            'id': element.id,
            'valor': element.indeferidas
        }, this.solicitacoesdeferidasMaxima);

        this.solicitacoesMDAMinima = rumble({
            'id': element.id,
            'valor': element.media_atendimento_dias
        }, this.solicitacoesMDAMinima, -1);
        this.solicitacoesMDAMaxima = rumble({
            'id': element.id,
            'valor': element.media_atendimento_dias
        }, this.solicitacoesMDAMaxima);
    });
}

/*
    Compara os valores dos parametros xxxMaixmo e xxxMinimo e devolve o correspondete.
    Param mulpiplier: ignore ou mande valor > 0 se quiser que retorne o MAIOR ente eles, PASSE UM VALOR < 0 se quiser que retorne o MENOR.
*/
function rumble (contender, defender, multiplier) {
    multiplier = (multiplier && multiplier < 0 ? multiplier = -1 : multiplier = 1);
    return ((contender.valor) * multiplier > (defender.valor) * multiplier || defender.valor == 0) ? contender : defender;
}

// Se id_solicitacao for null\undefined ele usa o bloco principal de dados
function mapaDeCalor (id, id_solicitacao) {
    var sub = _.find(RECURSO.data, (element) => { return element.id === id; });
    if (id_solicitacao && !isNaN(id_solicitacao)) {
        var dados = _.find(sub.servicos, (element) => { return element.id_solicitacao === id_solicitacao; });
       
        return this.calcularMapa(dados.total, dados.finalizadas, 100);
    } else {
       
        return this.calcularMapa(sub.total, sub.finalizadas, 100);
    }
}

// Divide o valor multiplicado pela proporcao pelo total
// se a proporçao for null/undefined sera considerada 100%
function calcularMapa (total, valor, proporcao) {
    var p = (proporcao && !isNaN(proporcao)) ? proporcao : 100;


    var h = valor * 100 / total;
  
    return 'hsl(' + parseInt(h) + ',100%, 30%)';
}
